import React from "react";
import PropTypes from "prop-types";
import Link from "../Link";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";

import * as styles from "../Button/component.module.less";
import { useContext } from "react";
import ElementContext from "../ElementContext";

function Button({
    className,
    children,
    background,
    type,
    htmlType,
    disabled = false,
    active = false,
    icon = "",
    iconPosition,
    onClick = () => {},
    renderAs = "button",
    ...others
}) {
    const { isLightBg } = useContext(ElementContext);

    let buttonClass = gcs(
        className,
        [disabled, styles.disabled],
        [active, styles.active],
        [icon, styles[icon]],
        [icon && iconPosition === "left", styles.btnIconBefore],
        [icon && iconPosition !== "left", styles.btnIconAfter],
        [background === "dark" || isLightBg === false, styles.darkBackground]
    );

    switch (type) {
        case "cta":
            buttonClass = gcs(styles.btnCta, buttonClass);
            break;
        case "primary":
            buttonClass = gcs(styles.btnPrimary, buttonClass);
            break;
        case "secondary":
            buttonClass = gcs(styles.btnSecondary, buttonClass);
            break;
        case "prev":
            buttonClass = gcs(styles.btnPrev, buttonClass, styles.slideBtn);
            break;
        case "next":
            buttonClass = gcs(styles.btnNext, buttonClass, styles.slideBtn);
            break;
        case "extend":
            buttonClass = gcs(styles.btnExtend, buttonClass);
            break;
        default:
            return null;
    }

    return (
        <>
            {renderAs === "link" ? (
                <Link linkClass={buttonClass} onClick={onClick} {...others}>
                    {children}
                </Link>
            ) : (
                <button
                    className={buttonClass}
                    onClick={onClick}
                    type={htmlType}
                    disabled={disabled}
                    {...others}
                >
                    <span>{children}</span>
                </button>
            )}
        </>
    );
}

Button.propTypes = {
    type: PropTypes.string.isRequired
};

export { Button };
